export const filterOutNullsy = <T>(collection: Array<T | null | undefined>): Array<T> => {
  return collection.filter((entry) => entry !== undefined && entry !== null) as T[];
};
